module.exports = __webpack_public_path__ + "static/employee_rih-f7226c69a9085bd4b7c7584b6ca5e60f.jpg";